// useBookingDetail — read-only booking + audit log + receipt link.
//
// GET /api/v1/collections/bookings/:enc_id returns BookingDetailResponse:
//   { booking, related_vehicles, logs, receipt }
// `related_vehicles` is empty for single-vehicle bookings.

import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { BookingDetailResponse } from '../../../types/api';

export function useBookingDetail(encId: string | null | undefined) {
  return useQuery<BookingDetailResponse>({
    queryKey: queryKeys.bookings.detail(encId ?? ''),
    queryFn: async () => {
      if (!encId) throw new Error('useBookingDetail called without an enc_id');
      const res = await apiClient.get<BookingDetailResponse>(
        endpoints.bookings.detail(encId),
      );
      if (!res.data) throw new Error('Booking detail response missing data');
      return res.data;
    },
    enabled: !!encId,
    staleTime: 30_000,
  });
}
